import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { Invoice } from "../../order/model/invoice.model";

export class DepositModel extends EntityBase {
  public Id: number;
  public InvoiceId?: number;
  public Invoice: Invoice;
  public ServingFoodDate: Date;
  public ServingFoodTime: string;
  public MealTime?: number;
  public DeliveryType?: number;
  public ClearType?: number;
  public NumberOfPeople?: number;
  public NumberOfCooks?: number;
  public DepositAmount?: number;
  public ServicesAmount?: number;
  public FoodPricePerson?: number;
  public RowVersion: any;
  public DepositPersonnelList: DepositPersonnelModel[];
  public Changes: DepositChanges[];

  constructor() {
    super();
    this.Id = 0;
    this.InvoiceId = null;
    this.Invoice = null;
    this.ServingFoodDate = null;
    this.ServingFoodTime = "";
    this.MealTime = null;
    this.DeliveryType = null;
    this.ClearType = null;
    this.NumberOfCooks = null;
    this.NumberOfPeople = null;
    this.DepositPersonnelList = [];
    this.DepositAmount = null;
    this.FoodPricePerson = null;
    this.ServicesAmount = 0;
    this.RowVersion = null;
    this.CreatedDate = null;
  }
}

export class DepositPersonnelModel extends EntityBase {
  public PersonnelId?: number;
  public PersonnelTitle: string;
  public Amount?: number;
  public RowVersion: any;
}

export class DepositHistoryModel extends DepositModel {}

export class DepositPersonnelHistoryModel extends DepositPersonnelModel {}

export class DepositChanges extends EntityBase {
  public ChangedFieldCode: DepositChangedFieldEnum;
}

export enum DepositChangedFieldEnum {
  ServingFoodDate = 1,
  ServingFoodTime,
  MealTime,
  DeliveryType,
  ClearType,
  NumberOfPeople,
  NumberOfCooks,
  DepositAmount,
  ServicesAmount,
}
